<div class="rate">
  <nz-rate [(ngModel)]="value"
           [nzAllowHalf]="allowHalf"
           [nzAllowClear]="allowClear"
           [ngClass]="cssClass"
           [ngStyle]="cssStyle"></nz-rate>
</div>
